import * as z from 'zod';

export const LoginSchema = z.object({
  email: z.string().email(),
  password: z.string().min(1, {
    message: 'Password is required',
  }),
  code: z.optional(z.string()),
});

export const RegisterSchema = z.object({
  name: z
    .string()
    .min(1, { message: 'Name is required' })
    .regex(/^[\p{L}\s'-]+$/u, {
      message: 'Name can only contain letters, spaces, hyphens and apostrophes',
    })
    .refine(
      (val) => {
        const parts = val.trim().split(/\s+/);
        return parts.length >= 2 && parts.every((p) => p.length >= 2);
      },
      { message: 'Please enter your first and last name' }
    ),
  email: z.string().email(),
  password: z.string().min(6, {
    message: 'Minimum 6 characters required',
  }),
  website: z.string().optional(), // honeypot field — must remain empty
});

export const ResetPasswordSchema = z.object({
  email: z.string().email(),
});

export const NewPasswordSchema = z.object({
  password: z.string().min(6, {
    message: 'Minimum 6 characters required',
  }),
});
